export const DEFAULT_LANGUAGE = "ru";
export const LANGUAGE_STORAGE_KEY = "exordos-lang";
export const SUPPORTED_LANGUAGES = ["en", "ru"] as const;

export type AppLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export function normalizeLanguage(language: string | null | undefined): AppLanguage {
  const normalized = language?.toLowerCase() ?? "";
  if (normalized.startsWith("en")) return "en";
  if (normalized.startsWith("ru")) return "ru";
  return DEFAULT_LANGUAGE;
}

export function getNextLanguage(language: AppLanguage): AppLanguage {
  return language === "ru" ? "en" : "ru";
}
